export default "__VITE_ASSET__fad94f11__"